import { render, staticRenderFns } from "./ReportGroups.vue?vue&type=template&id=6cbc1787&scoped=true&"
import script from "./ReportGroups.vue?vue&type=script&lang=js&"
export * from "./ReportGroups.vue?vue&type=script&lang=js&"
import style0 from "./ReportGroups.vue?vue&type=style&index=0&id=6cbc1787&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbc1787",
  null
  
)

export default component.exports